import React, { useEffect, useState } from "react";
import Select from 'react-select';
import moment from 'moment';

import PanelTemplate from "../../templates/Panel";
import Table from "../../components/Table";
import Box from "../../components/Box";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import PageHeader from "../../components/PageHeader";
import FilterSimple from "../../components/FilterSimple";
import DotStatus from "../../components/DotStatus";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import api from "../../services/api";
import { toast } from "react-toastify";
import { renderError } from "../../helpers/errors";
import axios from "axios";
import InputRadio from "../../components/InputRadio";
import origins from "../../seeds/origins";
import { ModalDelete } from "../../components/ModalDelete";
import { getToken, hasPermission } from "../../services/auth";
import Pagination from "../../components/Pagination";

const types = [
    {label: 'Cliente', value: 'customer'}
];

if(hasPermission('company_supplier')){
    types.push({label: 'Fornecedor de gravação', value: 'customization'});
    types.push({label: 'Fornecedor de produto', value: 'product'});
}
if(hasPermission('company_billing')){
    types.push({label: 'Faturamento', value: 'billing'});
}

export const CompanyList = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState('');

    const [companies, setCompanies] = useState([]);
    const [data, setData] = useState({header: [], rows: []});

    const [showCreateCompany, setShowCreateCompany] = useState(false);

    const [companyPfPj, setCompanyPfPj] = useState('pj');

    const [companyTradeName, setCompanyTradeName] = useState('');
    const [companyCompanyName, setCompanyCompanyName] = useState('');
    const [companyCnpj, setCompanyCnpj] = useState('');
    const [companyPhone, setCompanyPhone] = useState('');

    const [companyToDelete, setCompanyToDelete] = useState(null);

    const [companyType, setCompanyType] = useState([]);
    const [origin, setOrigin] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [totalResults, setTotalResults] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        getCompanies();
    }, [currentPage,filters]);

    useEffect(() => {
        if(!showCreateCompany) clean();
    }, [showCreateCompany]);

    useEffect(() => {
        generateData();
    }, [companies]);

    const generateData = () => {
        let header = ['Código', 'Nome fantasia', 'CNPJ', 'Onde conheceu', 'Responsável', 'Cadastrado em', 'Atualizado em'];
        const rows = [];

        if(hasPermission('delete_company')){
            header.push('');
        }

        companies.map(company => {
            let alert = false;

            if(company.cnpj === null) alert = true;
            if(company.zip_code === null) alert = true;
            if(company.street === null) alert = true;
            if(company.number === null) alert = true;
            if(company.city === null) alert = true;
            if(company.state === null) alert = true;
            if(company.district === null) alert = true;

            let buttons = [];
            let canEdit = true;

            if(company.type.includes('billing') && !hasPermission('company_billing')){
                canEdit = false;
            }
            if(company.type.includes('product') && !hasPermission('company_supplier')){
                canEdit = false;
            }
            if(company.type.includes('customization') && !hasPermission('company_supplier')){
                canEdit = false;
            }

            let canDelete = hasPermission('delete_company') && canEdit;

            if(canDelete){
                buttons.push(
                    <Button type={`delete`} svg={`delete`} action={() => setCompanyToDelete(company.id)} />
                );
            }

            

            rows.push({
                data: [
                    company.code,
                    <span>{company.trade_name} {alert ? <span className="data-alert">Incompleto</span> : ''}</span>,
                    company.cnpj,
                    company.origin,
                    company?.admin?.name,
                    company.created_at ? moment(company.created_at).format('DD/MM/YYYY HH:mm') : '',
                    company.created_at ? moment(company.updated_at).format('DD/MM/YYYY HH:mm') : ''
                ],
                buttons,
                to: canEdit ? `/company/edit/${company.id}` : '#',
                id: canDelete ? company.id : null,
                disable: !canEdit
            })
        });

        setData({header, rows});
    }

    const getCompanies = () => {
        setCompanies([]);
        setLoading(true);

        if (typeof cancelToken != typeof undefined) {
            window.cancelToken.cancel()
        }
      
        window.cancelToken = axios.CancelToken.source();

        api.get(`/company/paginate?${filters}&page=${currentPage}`, {
            cancelToken: window.cancelToken.token
        }).then(res => {
            setCompanies(res.data.resources.data);
            setCurrentPage(res.data.resources.current_page);
            setLastPage(res.data.resources.last_page)
            setPerPage(res.data.resources.per_page)
            setTotalResults(res.data.resources.total)
            setHasNextPage(res.data.resources.next_page_url !== null);
            setHasPrevPage(res.data.resources.prev_page_url !== null);
        }).catch(error => {
            
        }).then(() => setLoading(false));
    }

    const storeCompany = () => {
        setLoading(true);

        api.post(`/company`, {
            phone: companyPhone,
            trade_name: companyTradeName,
            company_name: companyCompanyName,
            cnpj: companyCnpj,
            type: companyType,
            origin
        }).then(res => {
            toast.success('Empresa cadastrada com sucesso');
            navigate(`/company/edit/${res.data.resource.id}`)
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const clean = () => {
        setCompanyTradeName('');
        setCompanyCompanyName('');
        setCompanyCnpj('');
        setCompanyType([]);
    }

    const deleteCompany = () => {
        setLoading(true);

        api.delete(`/company/${companyToDelete}`).then(res => {
            setCompanyToDelete(null);
            getCompanies();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const deleteMultipleCompanies = () => {
        setLoading(true);

        api.delete(`/company/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getCompanies();
            setShowConfirmMultipleDelete(false);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const handleSetFilter = value => {
        setCurrentPage(1);
        setFilters(value);
    }

    return (
        <>
            <ModalDelete
                show={showConfirmMultipleDelete}
                text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'empresas' : 'empresa'}</strong>?</p>}
                action={deleteMultipleCompanies}
                loading={loading}
                close={() => setShowConfirmMultipleDelete(false)}
            />
            <ModalDelete
                show={companyToDelete !== null}
                action={deleteCompany}
                loading={loading}
                close={() => setCompanyToDelete(null)}
            />
            <Modal
                title={`Cadastrar empresa`}
                show={showCreateCompany}
                close={() => setShowCreateCompany(false)}
                footer={
                    <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Cadastrar`}
                        svg={`save-white`}
                        action={storeCompany}
                        loading={loading}
                    />
                }
            >
                <div className="section">
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`CNPJ`} change={setCompanyCnpj} value={companyCnpj} mask={`convertToCnpj`} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Input type={`text`} label={`Razão social`} change={setCompanyCompanyName} value={companyCompanyName} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Input type={`text`} label={`Nome fantasia`} change={setCompanyTradeName} value={companyTradeName} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Input type={`text`} label={`Telefone`} change={setCompanyPhone} value={companyPhone} mask={`convertToPhone`} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <InputSelect label={`Tipo`} isMulti={true} options={types} change={setCompanyType} value={companyType} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <InputSelect label={`Onde nos conheceu`} options={origins} change={setOrigin} value={origin} />
                        </div>
                    </div>      
                                 
                </div>
            </Modal>
            <PanelTemplate id="company-list">
                <PageHeader
                    left={
                        <FilterSimple 
                            params={[
                                {name: 'Nome fantasia', key: '[trade_name]', type: 'text' },
                                {name: 'Razão social', key: '[company_name]', type: 'text' },
                                {name: 'CNPJ', key: '[cnpj]', mask: 'convertToCnpj', type: 'text' },
                                {name: 'Código', key: '[code]', type: 'text' },
                                {name: 'Onde nos conheceu', key: '[origin]', type: 'text'}
                            ]}
                            filter={handleSetFilter}
                        />
                    }

                    right={
                        <>
                            {hasPermission('delete_company') && selectedIds.length > 0 &&
                                <Button 
                                type={`secondary`} 
                                size={`small`} 
                                svg={`delete`}
                                text={`Excluir ${selectedIds.length} selecionados`} 
                                action={() => setShowConfirmMultipleDelete(true)}  
                                />
                            }
                            {hasPermission('export_company') &&
                                <Button type={`secondary`} size={`small`} text={`Exportar empresas`} action={() => window.open(`${process.env.REACT_APP_URL}/company/export?_token=${getToken()}`)}  />
                            }
                            {hasPermission('create_company') &&
                                <Button type={`primary`} size={`small`} text={`Cadastrar empresa`} svg="plus-white" action={() => setShowCreateCompany(true)}  />
                            }
                        </>
                    }
                />
                
                <Box className={`no-padding with-pagination`}>
                    <Table 
                        header={data.header} 
                        rows={data.rows} 
                        loading={loading} 
                        checks={true} 
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                    />
                </Box>
                {!loading &&
                    <Pagination
                        currentPage={currentPage}
                        lastPage={lastPage}
                        perPage={perPage}
                        totalResults={totalResults}
                        hasNextPage={hasNextPage}
                        hasPrevPage={hasPrevPage}
                        setCurrentPage={setCurrentPage}
                    />
                }
            </PanelTemplate>
        </>
    );
}

export default CompanyList;